/** @format */

import PrefixedInput from './PrefixedInput';

export default PrefixedInput;

export * from './PrefixedInput';
